import { useContext, useState } from "react";
import { getValidIBO } from "../helpers/ibo.helper";
import { useNavigate } from "react-router-dom";
import { alertNotification } from "../utils/alerts";
import { IboContext } from "../context/iboContext";

const useIBO = (t, toggleModal) => {
  const navigate = useNavigate();
  const { setIboInfoLocal } = useContext(IboContext);
  const [iboCode, setIboCode] = useState({ iboCode: "" });
  const [invalidIbo, setInvalidIbo] = useState(false);
  const [invalidMessage, setInvalidMessage] = useState("");
  const [codeByUrl, setCodeByUrl] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIboCode({
      ...iboCode,
      [name]: value,
    });
  };

  const validateIBO = async (byUrl) => {
    
    const iboResponse = await getValidIBO(iboCode.iboCode);
    if (iboResponse.status === 200) {
      const iboInfo = { ...iboResponse.data.data };
     
      setIboInfoLocal(iboInfo);
      toggleModal();
      navigate("/");
    } else {
      if (!byUrl) {
        setInvalidIbo(true);
        setInvalidMessage(t("ibo.invalid"));
      } else {
        setCodeByUrl(true);
        navigate("/");
        alertNotification(t("Alert error"));
      }
    }
  };

  return {
    handleChange,
    validateIBO,
    invalidIbo,
    invalidMessage,
    setIboCode,
    iboCode,
    codeByUrl,
  };
};

export default useIBO;
